import React, { useEffect } from "react";
import "./WhyChooseFlutter.css";

const WhyChooseFlutter = () => {
    useEffect(() => {
        const items = document.querySelectorAll(".wf-item");

        items.forEach((el, i) => {
            el.style.opacity = "0";
            el.style.transform = "translateX(-60px)";

            setTimeout(() => {
                el.style.transition = "0.8s ease";
                el.style.opacity = "1";
                el.style.transform = "translateX(0)";
            }, i * 180);
        });
    }, []);

    const points = [
        {
            title: "One Code, All Platforms",
            desc: "Build apps for Android, iOS, Web & Desktop using single codebase.",
        },
        {
            title: "Native Like Performance",
            desc: "Flutter compiles to native ARM code for super smooth performance.",
        },
        {
            title: "Fast UI Development",
            desc: "Hot Reload lets you see changes instantly without rebuilding.",
        },
        {
            title: "Beautiful Custom UI",
            desc: "Create pixel-perfect UI with fully customizable widgets.",
        },
        {
            title: "Lower Development Cost",
            desc: "One team, one codebase = reduced time and cost.",
        },
    ];

    return (
        <>
            <section className="wf-section">
                {/* Background shapes */}
                <div className="wf-bg wf-bg1"></div>
                <div className="wf-bg wf-bg2"></div>

                <div className="wf-grid">
                    {/* LEFT IMAGE / VISUAL */}
                    <div className="wf-left">
                        <div className="wf-card-main">
                            <h2>
                                Why Choose <span>Flutter?</span>
                            </h2>

                            <p>
                                A modern framework that helps you build
                                fast, beautiful and scalable applications
                                across all platforms.
                            </p>

                            <div className="wf-badge">
                                ⚡ 60 FPS Smooth UI
                            </div>
                        </div>
                    </div>

                    {/* RIGHT CONTENT */}
                    <div>
                        <div className="wf-heading-wrap">
                            <h2 className="wf-title">
                                Why Choose{" "}
                                <span>Flutter</span>
                            </h2>

                            <p className="wf-desc">
                                Flutter is the most powerful cross-platform
                                framework used by startups and enterprises
                                worldwide.
                            </p>
                        </div>

                        {/* Timeline Style List */}
                        <div className="wf-list">
                            {points.map((item, i) => (
                                <div
                                    key={i}
                                    className="wf-item"
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform =
                                            "translateX(10px)";
                                        e.currentTarget.style.borderColor =
                                            "#E8212A";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform =
                                            "translateX(0)";
                                        e.currentTarget.style.borderColor =
                                            "#f2f2f2";
                                    }}
                                >
                                    <div className="wf-dot"></div>

                                    <div>
                                        <h4 className="wf-item-title">
                                            {item.title}
                                        </h4>

                                        <p className="wf-item-desc">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WhyChooseFlutter;